import { Component } from '@verndale/core';
import Cookies from 'js-cookie';
import { open, close } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.id = this.el.dataset.id;

    this.dom = {
      content: this.el.querySelector('.information-alert__content'),
      toggle: this.el.querySelector('.information-alert__toggle'),
      hide: this.el.querySelector('.information-alert__hide'),
      show: this.el.querySelector('.information-alert__show'),
      close: this.el.querySelector('.information-alert__close')
    };

    this.shouldDisplayAlert();
  }

  shouldDisplayAlert() {
    this.alerts = Cookies.get('landrys_alerts');

    if (this.alerts) {
      this.alerts = JSON.parse(this.alerts);

      if (this.alerts.includes(this.id)) {
        return this.el.remove();
      }
    } else {
      this.alerts = [];
    }

    open({
      element: this.el,
      onComplete: () => (this.el.style.height = 'auto')
    });
  }

  addListeners() {
    this.dom.toggle.addEventListener('click', this.handleToggle.bind(this));
    this.dom.close.addEventListener('click', this.handleClose.bind(this));
  }

  handleToggle() {
    if (this.dom.toggle.getAttribute('aria-expanded') === 'true') {
      this.dom.toggle.setAttribute('aria-expanded', false);
      close({
        element: this.dom.content,
        onComplete: () => {
          this.dom.content.style.display = 'none';
        }
      });
    } else {
      this.dom.toggle.setAttribute('aria-expanded', true);
      this.dom.content.style.display = 'block';
      open({
        element: this.dom.content,
        onComplete: () => {
          this.dom.content.focus();
          this.dom.content.style.height = 'auto';
        }
      });
    }
  }

  handleClose() {
    this.alerts.push(this.id);

    close({
      element: this.el,
      onComplete: () => {
        Cookies.set('landrys_alerts', JSON.stringify(this.alerts), {
          expires: 36500
        });
        this.el.remove();
      }
    });
  }
}

export default Module;
